import OrderList from './OrderList.container'

export default OrderList
